import { chatbotResponse } from "./chatbot.service";
export default {
  namespaced: true,
  state: {
    isLoading: false,
    messages: [],
  },

  actions: {
    chatbotResponseAction: async ({ commit }, payload) => {
      try {
        commit("setChantInfo", {
          id: new Date().toString() + Math.floor(Math.random() * 100),
          text: payload.message,
          time: new Date().toLocaleTimeString().slice(0, 5),
          sender: "user",
          buttons: [],
        });
        const data = await chatbotResponse(payload);
        if (data && data.data && Array.isArray(data.data) && data.data.length) {
          data.data.forEach((responseMessage) => {
            const { text } = responseMessage;
            const jsonMatch = text.match(/{.*}/);
            if (jsonMatch) {
              try {
                let cleanJsonString = jsonMatch[0]
                  .replace(/'/g, '"')
                  .replace(/\bFalse\b/g, "false")
                  .replace(/\bTrue\b/g, "true");
                const orderData = JSON.parse(cleanJsonString);
                const orders = orderData.data.map((el) => {
                  const paymentInfo = el.payments.items[0];
                  const orderMessage = `
                  - Product Name: ${el.items[0].name}
                  - Final Price: ₹${el.items[0].finalPrice}
                  - Quantity: ${el.items[0].qty}
                  - Order ID: ${el.orderId}
                  - Order Status: ${paymentInfo.status}
                  - Payment Type: ${paymentInfo.type}
                `;
                  el.orderMessage = orderMessage;
                  return el;
                });
                commit("setChantInfo", {
                  id: new Date().toString() + Math.floor(Math.random() * 100),
                  text: orders,
                  time: new Date().toLocaleTimeString().slice(0, 5),
                  sender: "bot",
                  buttons: [],
                });
              } catch (error) {
                console.error("Failed to parse order JSON:", error);
              }
            } else {
              commit("setChantInfo", {
                id: new Date().toString() + Math.floor(Math.random() * 100),
                text,
                time: new Date().toLocaleTimeString().slice(0, 5),
                sender: "bot",
                buttons: responseMessage.buttons || [],
              });
            }
          });
        }
        return data;
      } catch (e) {
        console.error(e);
      }
    },

    // NEW: Option-based chatbot API action
    fetchOptionsAction: async ({ commit }, payload) => {
      try {
        // No user message commit here, only bot response
        const data = await chatbotResponse(payload);
        if (data && Array.isArray(data) && data.length) {
          const custom = data[0].custom || {};
          const options = custom.options || [];
          commit("setChantInfo", {
            id: new Date().toString() + Math.floor(Math.random() * 100),
            text: custom.message || "Please choose an option:",
            time: new Date().toLocaleTimeString().slice(0, 5),
            sender: "bot",
            buttons: options.map((opt) => ({
              title: opt.message,
              payload: JSON.stringify({
                optionType: opt.optionType,
                nextParent: opt.nextParent,
              }),
            })),
          });
        }
        return data;
      } catch (e) {
        console.error(e);
      }
    },

    sendHelloMessage: async ({ commit }) => {
      try {
        const data = await chatbotResponse({
          metadata: {
            db_name: "eparisheva",
            type: "trigital_chat_vector_search",
          },
          message: "hello",
        });
        if (data && data.data && Array.isArray(data.data) && data.data.length)
          data.data.forEach((responseMessage) => {
            const { text, buttons } = responseMessage;
            commit("setChantInfo", {
              id: new Date().toString() + "b",
              text,
              time: new Date().toLocaleTimeString().slice(0, 5),
              sender: "bot",
              buttons,
            });
          });
        return data;
      } catch (e) {
        console.error(e);
      }
    },
  },
  mutations: {
    setChantInfo: (state, data) => {
      state.messages.push(data);
    },
  },
};
